var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnavailableUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_929_36952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.25 5.625C5.25 3.55725 6.93225 1.875 9 1.875C11.0677 1.875 12.75 3.55725 12.75 5.625C12.75 7.69275 11.0677 9.375 9 9.375C6.93225 9.375 5.25 7.69275 5.25 5.625ZM12.0878 10.1783C11.6685 10.0718 11.2125 10.1318 10.8353 10.3418C9.69677 10.9748 8.30323 10.9748 7.16473 10.3418C6.78823 10.1325 6.3315 10.0733 5.91225 10.1783C4.41825 10.5555 3.375 11.9115 3.375 13.4753V14.2335C3.375 14.712 3.50249 15.18 3.74474 15.588C3.94199 15.9195 4.31176 16.1257 4.70851 16.1257H13.2908C13.6875 16.1257 14.0572 15.9202 14.2545 15.5872C14.4967 15.18 14.6243 14.712 14.6243 14.2335V13.4753C14.625 11.9115 13.5818 10.5555 12.0878 10.1783Z",
    fill: "#E04167"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.3123,
    y: 15.5025,
    width: 17.9821,
    height: 0.961925,
    transform: "rotate(-47.5833 2.3123 15.5025)",
    fill: "#F9E0E6",
    stroke: "#F9E0E6",
    strokeWidth: 0.961925
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.69329,
    y: 16.8013,
    width: 18.04,
    height: 0.904034,
    rx: 0.452017,
    transform: "rotate(-47.5833 3.69329 16.8013)",
    fill: "#E04167",
    stroke: "#E04167",
    strokeWidth: 0.904034
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_929_36952"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnavailableUser);
export default __webpack_public_path__ + "static/media/unavailable-user.4cab41d15dee750abacc70214952838c.svg";
export { ForwardRef as ReactComponent };